import utils from '@/mixins/utils'

export function filtro(cadastros, exibirVermelhos, exibirVerdes) {
  let cadastros_filtrados = cadastros

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.num_prim_cons_odonto == null) {
        return true
      }
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.num_prim_cons_odonto != null) {
        return true
      }
    })
  }

  return cadastros_filtrados
}
